import { StoreKeys } from './Constants';
import { REDUX_STORE_SLICES } from '../services/exports/Constants';
import { migratePersistedOrder } from '../utils/on-site';
import { StoreInterface } from './types';

export const getPreloadedState = (key: StoreKeys): Partial<StoreInterface> => {
  try {
    const persisted = localStorage.getItem(`persist:${key}`);
    if (!persisted) return {};

    const parsed = JSON.parse(persisted);
    const state: Partial<StoreInterface> = {};

    for (const key in parsed) {
      if (key === '_persist') continue;
      state[key as keyof StoreInterface] = safeParse(parsed[key]);
    }

    // Read straight from storage, so redux-persist's migrate never sees it.
    const order = state[REDUX_STORE_SLICES.ORDER] as { cached_order?: Record<string, unknown> } | undefined;

    if (order?.cached_order) {
      state[REDUX_STORE_SLICES.ORDER] = { ...order, cached_order: migratePersistedOrder(order.cached_order) } as never;
    }

    return state;
  } catch {
    return {};
  }
};

const safeParse = (value: string): any => {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
